import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingSpinner } from "@/components/shared/LoadingSpinner";

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const { isAuthenticated, isLoading, isOnboarding } = useAuth();
  const location = useLocation();

  console.log("AuthWrapper: Rendering with state:", {
    isAuthenticated,
    isLoading,
    isOnboarding,
    path: location.pathname,
  });

  // Always allow access to auth and onboarding paths
  if (location.pathname === "/auth" || location.pathname === "/onboarding") {
    console.log("AuthWrapper: Allowing access to public path:", location.pathname);
    return <>{children}</>;
  }

  // Show loading state only during initial check
  if (isLoading) {
    console.log("AuthWrapper: Showing loading state during initial auth check");
    return (
      <div className="flex items-center justify-center h-screen w-screen">
        <LoadingSpinner message="Loading your account..." />
      </div>
    );
  }

  // Allow access during onboarding
  if (isOnboarding) {
    console.log("AuthWrapper: User is in onboarding, allowing access");
    return <>{children}</>;
  }

  // Redirect to auth if not authenticated
  if (!isAuthenticated) {
    console.log("AuthWrapper: User not authenticated, redirecting to auth page");
    return <Navigate to="/auth" replace />;
  }

  console.log("AuthWrapper: User authenticated, showing protected content");
  return <>{children}</>;
};
